import styled from 'styled-components';

export const PageContainer = styled.div`
  background-color: white;
  overflow-y: auto;
  width: 100%;
`;

export const ShiftTypeHeader = styled.div`
  background-color: var(--primary-blue, #0B4598);
  color: var(--common-white-main, #fff);
  padding: 12px;
  text-align: center;
  font-weight: 500;
  font-size: 16px;
`;

export const ContentWrapper = styled.div`
  padding: 0 0 20px 0;
  max-width: 600px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
`;

export const LocationHeader = styled.div`
  text-align: center;
  padding: 24px 16px;
`;

export const OfficeName = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: var(--text-primary, #333);
  margin: 0 0 8px 0;
`;

export const LocationInfo = styled.div`
  color: var(--text-secondary, #666);
  font-size: 14px;
  line-height: 1.4;
`;

export const Card = styled.div`
  background: white;
  padding: 20px;
  margin: 0 16px 16px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`;

export const MainCard = styled(Card)`
  padding: 24px 20px;
`;

export const ProfessionalName = styled.h2`
  text-align: center;
  margin: 0 0 20px 0;
  color: var(--text-primary, #333);
  font-size: 22px;
  font-weight: 600;
`;

export const DetailRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
  
  &:last-of-type {
    margin-bottom: 12px;
  }
`;

export const IconWrapper = styled.div`
  flex-shrink: 0;
  margin-top: 2px;
  color: var(--primary-blue, #0B4598);
`;

export const DetailContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
`;

export const DetailLabel = styled.span`
  font-size: 14px;
  color: var(--text-secondary, #666);
`;

export const DetailValue = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary, #333);
`;

export const DownTimeNote = styled.div`
  font-size: 14px;
  color: var(--text-secondary, #666);
  padding-top: 12px;
  margin-top: 12px;
  border-top: 1px solid var(--divider, #e5e5e5);
`;

export const PaidText = styled.span<{ $isUnpaid?: boolean }>`
  color: ${props => props.$isUnpaid ? 'var(--primary-main, #FB7672)' : 'var(--success-main, #13CA82)'};
  font-weight: 600;
`;

export const PaymentCard = styled(Card)``;

export const PaymentHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
`;

export const PaymentInfo = styled.div`
  flex: 1;
`;

export const PaymentTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary, #333);
  margin: 0 0 4px 0;
`;

export const PaymentSubtitle = styled.p`
  font-size: 14px;
  color: var(--text-secondary, #666);
  margin: 0;
`;

export const InvoiceLink = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--primary-blue, #0B4598);
  background: none;
  border: none;
  font-size: 14px;
  font-weight: 500;
  padding: 0;
  padding-left: 36px;
  cursor: pointer;
  
  &:hover {
    text-decoration: underline;
  }
`;

export const StatusSection = styled(Card)`
  padding: 0;
  overflow: hidden;
`;

export const StatusRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid var(--divider, #e5e5e5);
  
  &:last-child {
    border-bottom: none;
  }
`;

export const StatusLabel = styled.span`
  font-size: 16px;
  color: var(--text-primary, #333);
  font-weight: 500;
`;

export const StatusValue = styled.div`
  font-size: 14px;
  color: var(--text-primary, #333);
`;

export const StatusBadge = styled.span<{ $status: 'pending' | 'done' | 'not-received' }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  
  ${props => props.$status === 'pending' && `
    background-color: var(--status-pending-bg, #FFF3CD);
    color: var(--status-pending-text, #856404);
  `}
  
  ${props => props.$status === 'done' && `
    background-color: var(--status-done-bg, #D4EDDA);
    color: var(--status-done-text, #155724);
  `}
  
  ${props => props.$status === 'not-received' && `
    background-color: var(--status-neutral-bg, #E9ECEF);
    color: var(--status-neutral-text, #495057);
  `}
`;

export const ActionButton = styled.button`
  background: none;
  border: none;
  color: var(--primary-blue, #0B4598);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 8px;
  
  &:hover {
    text-decoration: underline;
  }
`;

export const NotesSection = styled(Card)`
  box-sizing: border-box;
  overflow: hidden;
`;

export const NotesHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
`;

export const NotesTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary, #333);
  margin: 0;
`;

export const NotesTextarea = styled.textarea`
  width: 100%;
  max-width: 100%;
  min-height: 120px;
  margin: 0;
  padding: 12px;
  border: 1px solid var(--divider, #e5e5e5);
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  background-color: var(--background-default, #f9f9f9);
  box-sizing: border-box;
  
  &::placeholder {
    color: var(--text-disabled, #999);
  }
  
  &:focus {
    outline: none;
    border-color: var(--primary-blue, #0B4598);
    background-color: var(--common-white-main, white);
  }
`;

export const NotesLabel = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: var(--text-primary, #333);
  font-weight: 500;
`;

export const DoneButton = styled.button`
  display: block;
  width: calc(100% - 32px);
  margin: 24px 16px 40px;
  background-color: var(--primary-blue, #0B4598);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 16px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
  
  &:hover {
    opacity: 0.9;
  }
  
  &:active {
    transform: scale(0.98);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    width: calc(100% - 24px);
    margin: 24px 12px 60px;
    padding: 18px 24px;
    font-size: 18px;
  }
`;

export const ReminderText = styled.p`
  margin: 16px 0;
  padding: 12px;
  background-color: var(--info-light, #f0f8ff);
  border-radius: 8px;
  font-size: 13px;
  color: var(--text-secondary, #666);
  line-height: 1.5;
  
  strong {
    font-weight: 600;
  }
`;

export const ChatNowSection = styled.div`
  margin: 0 16px 16px;
`;

export const ChatNowButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: var(--common-white-main, #fff);
  border: 1px solid var(--text-primary, #1F2937);
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary, #1F2937);
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: var(--background-default, #f9f9f9);
  }
`; 